require('./draganddrop');
module.exports = 'ang-drag-drop';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-native-dragdrop/index.js
// module id = 359
// module chunks = 2